import { VCard } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,[_c('img',{attrs:{"src":_vm.qr_code,"width":"100%","height":"auto","alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }